'use client';

import useVelocityAccountStore from '../stores/useVelocityAccountsStore';

const useCurrentUserAccount = () => {
	const userAccount = useVelocityAccountStore(
		(s) => s?.accounts?.[s?.currentUserKey ?? '']
	);
	return userAccount;
};

export default useCurrentUserAccount;
